module.exports = __webpack_public_path__ + "media/images/site/CENSINO_FUND_2_APRENDER_FAZENDO-18336a34e8543ccd61bf8caa5db14491.jpg";